// extracted by css-extract-rspack-plugin
export default {"inputWrapper":"uvAHAlMv4mQIIIqp"};